import { EstimateInfo, EstimateMetricsAndMissingPrices, ProjectEstimate } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getEstimatesForProject(projectGuid: string) {
  return DesignService.get<readonly ProjectEstimate[]>(`estimates/forProject/${projectGuid}`);
}

export function postGenerateEstimatePdfForSharedComponentSet(estimateInfo: EstimateInfo, lookupCode: string) {
  return DesignService.fetchFile('estimates/getEstimatePdfForSharedComponentSet', {
    post: true,
    data: estimateInfo,
    params: new URLSearchParams({ lookupCode }),
  });
}

export function postGenerateEstimatePdfForProject(estimateInfo: EstimateInfo, projectGuid: string) {
  return DesignService.fetchFile('estimates/getEstimatePdfForProject', {
    post: true,
    data: estimateInfo,
    params: new URLSearchParams({ projectGuid }),
  });
}

export function postGenerateEstimateCsvForSharedComponentSet(estimateInfo: EstimateInfo, lookupCode: string) {
  return DesignService.fetchFile('estimates/getEstimateCsvForSharedComponentSet', {
    post: true,
    data: estimateInfo,
    params: new URLSearchParams({ lookupCode }),
  });
}

export function postGenerateEstimateCsvForProject(estimateInfo: EstimateInfo, projectGuid: string) {
  return DesignService.fetchFile('estimates/getEstimateCsvForProject', {
    post: true,
    data: estimateInfo,
    params: new URLSearchParams({ projectGuid }),
  });
}

export function getEstimateMetricsAndMissingPricesForSharedComponentSet(lookupCode: string) {
  return DesignService.get<EstimateMetricsAndMissingPrices>(
    `estimates/getEstimateMetricsAndMissingPricesForSharedComponentSet/${lookupCode}`,
  );
}

export function getEstimateMetricsAndMissingPricesForProject(projectGuid: string) {
  return DesignService.get<EstimateMetricsAndMissingPrices>(
    `estimates/getEstimateMetricsAndMissingPricesForProject/${projectGuid}`,
  );
}
